import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadProgressModal = ({ progress, onCancel }) => {
  return (
    <div className="fixed inset-0 z-dialog bg-background/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-gaming-lg p-6 md:p-8 max-w-md w-full">
        <div className="flex flex-col items-center space-y-6">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/20 rounded-full flex items-center justify-center">
            <Icon name="Upload" size={32} color="var(--color-primary)" className="md:w-10 md:h-10" />
          </div>

          <div className="w-full space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm md:text-base font-medium text-foreground">
                업로드 중...
              </span>
              <span className="text-sm md:text-base font-medium text-primary data-text">
                {progress}%
              </span>
            </div>

            <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-gaming rounded-full"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          <p className="text-sm md:text-base text-muted-foreground text-center caption">
            증명 이미지를 업로드하고 있습니다.\n잠시만 기다려주세요.
          </p>

          <button
            onClick={onCancel}
            className="px-6 py-2 md:py-3 bg-muted text-foreground rounded-md font-medium transition-gaming hover:bg-muted/80 active:translate-y-px"
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadProgressModal;